import { z } from 'zod';

import { nullishDefault } from '../../../utils/nullableDefault';

export const BeschaeftigungStudent = z.object({
    sonstigesEinkommenMonatlich: nullishDefault(z.number()),
});
